export const VIDEO_FILE_TYPES = [
  'mp4',
  'm4a',
  'mkv',
  'mov',
  'm4v',
  'avi',
];

export const IMAGE_FILE_TYPES = [
  'jpg',
  'JPG',
  'png',
  'PNG',
  'jpeg',
  'JPEG',
  'svg',
  'heif',
];

export const DOC_FILE_TYPES = ['doc', 'docx'];

export const PDF_FILE_TYPE = 'pdf';
